import { render, staticRenderFns } from "./TheEstimates.vue?vue&type=template&id=8b201784&scoped=true"
import script from "./TheEstimates.vue?vue&type=script&lang=js"
export * from "./TheEstimates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b201784",
  null
  
)

export default component.exports